module.exports = __webpack_public_path__ + "static/stage3-thumb-76922b8793ffa28803e82bdc96a155fe.jpg";